import React from "react";
import { Route, Routes, Redirect, useNavigate } from "react-router";
import ProtectedRoute from "./ProtectedRoute";
import AdminLoginScreen from "../user/admin/AdminLoginScreen";
import { useSelector } from "react-redux";
import AdminLogin from "../user/admin/AdminLogin";
import UserDownloadLisr from "../user/admin/UserDownloadLisr";
import MasterList from "../user/admin/MasterList";
import PasswordHistory from "../user/admin/PasswordHistory";
import UserBanking from "../user/admin/UserBanking";
import AccountStatementComponent from "../user/components/Accounts/AccountStatementComponent";
import AdminAccountProfile from "../user/admin/AdminAccountProfile";
import AdminBetlist from "../user/admin/AdminBetlist";
import Aaccountstatement from "../user/admin/Aaccountstatement";
import ActivityLog from "../user/admin/ActivityLog";
import Achecksportwiseresult from "../user/admin/Commision";
import Ariskmanagement from "../user/admin/Ariskmanagement";
import Aprofitdownline from "../user/admin/Aprofitdownline";
import AblockMarket from "../user/admin/AblockMarket";
import Abetlistlive from "../user/admin/Abetlistlive";
import AdminMyAccounts from "../user/admin/AdminMyAccounts";
import Banking from "../user/admin/Banking";

export default function AdminRoutes() {
  const { adminLogin } = useSelector((state) => state?.auth);
  // const navigate = useNavigate();

  const routesData = [
    // { path: "/admin", component: <AdminLogin /> },
    { path: "/admin/home", component: <AdminLoginScreen /> },
    { path: "/list", component: <UserDownloadLisr /> },
    { path: "/master/list", component: <MasterList /> },
    { path: "/my-account-master/profile", component: <AdminAccountProfile /> },
    { path: "/Aaccountstatement", component: <Aaccountstatement /> },
    { path: "/ABanking", component: <Banking /> },
    { path: "/AdminMyAccounts", component: <AdminMyAccounts /> },
    { path: "/Ariskmanagement", component: <Ariskmanagement /> },
    { path: "/AblockMarket", component: <AblockMarket /> },
    { path: "/Aprofitdownline", component: <Aprofitdownline /> },
    { path: "/ActivityLog", component: <ActivityLog /> },
    { path: "/Abetlistlive", component: <Abetlistlive /> },
    { path: "/password-history", component: <PasswordHistory /> },
    { path: "/banking", component: <UserBanking /> },
    { path: "/account-statement", component: <AccountStatementComponent /> },
    { path: "/account-statement", component: <AccountStatementComponent /> },
    { path: "/Achecksportwiseresult", component: <Achecksportwiseresult /> },
    { path: "/betlist", component: <AdminBetlist /> },
  ];

  return (
    <>
      <Routes>
        <Route element={<ProtectedRoute login={adminLogin} />}>
          {routesData.map((routes, index) => {
            return (
              <Route
                key={index}
                path={routes.path}
                element={routes.component}
              />
            );
          })}
        </Route>
        <Route path="/admin" element={<AdminLogin />} />
      </Routes>
    </>
  );
}